import { useDispatch } from 'react-redux';
import { testing } from '../../../store/auth/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { studentBaseUrl } from '../../../App';

const Testing = () => {
  const location = useLocation();
  const url = location.hash.split('#')[1];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(testing());
    const urlSplit = url?.split('?');
    navigate(
      urlSplit ? `${location.pathname.startsWith(studentBaseUrl) ? studentBaseUrl : ''}${urlSplit[0]}` : undefined,
      { replace: true },
    );
  }, [dispatch, location.pathname, navigate, url]);

  return <div />;
};

export default Testing;
